import styled from "styled-components";
import ReactTooltip from "react-tooltip";

const ToolTip = styled(ReactTooltip)`
  border-radius: 8px;
  padding: ${({ padding }) => padding || "12px"};
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0px;
  text-align: center;
  background-color: ${({ backgroundColor }) => backgroundColor || "#1c1928"};
  width: ${({ width }) => width || "fit-content"};
  box-shadow: 0px 2px 4px 0px #00000029;
  white-space: pre-wrap;

  &:after {
    display: ${({ noArrow }) => (noArrow ? "none" : "block")};
  }
  &.__react_component_tooltip.show {
    opacity: 1 !important;
  }
`;

export default ToolTip;
